import { render, staticRenderFns } from "./profession_list.vue?vue&type=template&id=98917fda&"
import script from "./profession_list.vue?vue&type=script&lang=js&"
export * from "./profession_list.vue?vue&type=script&lang=js&"
import style0 from "./profession_list.vue?vue&type=style&index=0&id=98917fda&prod&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports